import { useEffect, useState } from 'react';
import { fetchEventFromEE } from '@general/api/eventAPI';

const useEventEE = eventCode => {
    const [event, setEvent] = useState();

    useEffect(() => {
        if (!eventCode) {
            return;
        }

        (async () => {
            const response = await fetchEventFromEE(eventCode);
            if (response?.data && response.data.length > 0) {
                setEvent(response.data[0]);
            }
        })();
    }, [eventCode]);

    return { event };
};

export default useEventEE;
